import { useState } from "react";
import { Button } from "../ui/button";
import { usePreviewInfo, useRestartPreview } from "../../hooks/usePreviews";
import { errorMessage } from "../../hooks/useServers";
import { openPreview } from "./PreviewWindow";

// Botón «Previsualizar» del encabezado del chat: solo aparece en proyectos del taller.
export function PreviewButton({ projectId }) {
  const { data: info } = usePreviewInfo(projectId);
  const restart = useRestartPreview(projectId);
  const [message, setMessage] = useState("");

  if (!info?.is_workshop) return null;

  const running = (info.previews || []).some((p) => p.status === "running");
  const click = async () => {
    setMessage("");
    try {
      const view = await restart.mutateAsync();
      openPreview(view.token, view.title);
    } catch (e) {
      setMessage(errorMessage(e, "No se pudo abrir la vista previa."));
    }
  };

  return (
    <div className="flex items-center gap-2">
      <Button data-testid="preview-button" size="sm" variant="outline" onClick={click} disabled={restart.isPending}>
        {restart.isPending ? "Abriendo…" : running ? "▶ Previsualizar" : "▶ Previsualizar (reabrir)"}
      </Button>
      {message && (
        <span data-testid="preview-button-error" className="text-xs text-red-500 max-w-xs truncate" title={message}>
          {message}
        </span>
      )}
    </div>
  );
}
